<template>
  <div>
    <!-- 视频组件 -->
    <el-row style="display: flex">
      <template v-for="index in 5">
        <VideoUpload
          v-if="index <= videos.length + 1"
          :key="index"
          @upload-success="videoUploadSuccess"
          @changeTagType="video => changeVideoType(video, index - 1)"
          :video="videos[index - 1]"
          :options="tagOptions"
          @del="video => videoDel(video, index - 1)"
          aspectRatio="1:1,3:4,9:16"
          :limitDuration="300"
        />
      </template>
    </el-row>
    <el-row class="tips ft-12">
      <el-col>分辨率 >= 300p；时长上限为五分钟；宽高比支持1:1、3:4、9:16，最多上传五个</el-col>
      <el-col>视频格式：mp4、mov、m4v、flv、x-flv、wmv、rm、3gp、avi</el-col>
    </el-row>
  </div>
</template>

<script>
import VideoUpload from '@/components/Uploads/videoUploadWithTagType.vue';

export default {
  props: {
    props: { type: Object, required: true },
    value: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
  },
  components: {
    VideoUpload,
  },
  data() {
    return {
      videos: [],
    };
  },
  computed: {
    key() {
      return this.props.name;
    },
    tagOptions() {
      const children = this.props.dataSource?.children || [];
      return children.find(item => item.name === 'videoType')?.options || [];
    },
  },
  mounted() {
    this.videos = Array.isArray(this.value) ? [...this.value] : [];
  },
  methods: {
    // 转换数据格式的方法
    formatVideoData(videoList) {
      return videoList.map(video => {
        // 只保留需要的字段
        return {
          videoTips: video.videoTips,
          videoType: video.videoType,
          videoId: video.videoId,
          videoInfoJson: video,
        };
      });
    },
    // 生成唯一性videoId
    generateUniqueVideoId() {
      return `VID_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`.toUpperCase();
    },
    // 统一同步表单方法
    syncForm() {
      this.$emit('change', this.formatVideoData(this.videos));
    },
    // 视频上传成功
    videoUploadSuccess(video) {
      if (this.videos.length < 5) {
        this.videos.push({ ...video, videoId: this.generateUniqueVideoId(), videoType: this.tagOptions[0].value || '' });
        this.syncForm();
      }
    },
    // 删除视频
    videoDel(video, index) {
      this.videos.splice(index, 1);
      this.syncForm();
    },
    // 修改视频标签
    changeVideoType(video, index) {
      if (this.videos[index]) {
        this.videos[index].videoType = video.videoType;
        this.syncForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>